import { ReactElement, useContext } from 'react';

import { AuthModalContext } from '@/context/AuthModalContextProvider';
import { useGuideDuration } from '@/hooks/app/useGuideDuration';
import { useGuidePlay } from '@/hooks/app/useGuidePlay';
import { useUserState } from '@/hooks/store';

import { useMediaPlayerContext } from '../../contentPlayer/MediaPlayerProvider';
import { ClickableWrapper, Duration, PlayIcon, Subtitle, Title, Wrapper } from './styles';
import { MasterclassGuideRowProps } from './types';

const MasterclassGuideRow = ({ guide, onPlay }: MasterclassGuideRowProps): ReactElement => {
	const onGuidePlay = useGuidePlay();
	const user = useUserState();
	const { setIsModalOpen } = useContext(AuthModalContext);
	const { hideControls } = useMediaPlayerContext();
	const duration = useGuideDuration(guide?.asset?.duration);

	const onClick = async () => {
		if (user) {
			if (onPlay) {
				return await onPlay(guide.id);
			} else {
				return await onGuidePlay(guide.id);
			}
		} else {
			setIsModalOpen(true);
		}
	};

	// Some subtitles arrive with a leading space, which shows up as a visible indent against
	// the title above them.
	const subtitle = guide.subtitle?.trim();
	const title = `${guide.position - 1}. ${guide.title}`;

	return (
		<Wrapper>
			<ClickableWrapper isDisabled={hideControls} onClick={onClick} data-testid="masterclass-click-wrapper">
				<Title>{title}</Title>
				{subtitle && <Subtitle>{subtitle}</Subtitle>}
				{duration && <Duration>{duration}</Duration>}
			</ClickableWrapper>
			<PlayIcon aria-hidden />
		</Wrapper>
	);
};

export default MasterclassGuideRow;
